var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77977 7.80126C6.29842 8.8616 7.15792 9.71719 8.2206 10.231C8.29835 10.2678 8.38436 10.2838 8.47015 10.2773C8.55595 10.2708 8.63857 10.2421 8.7099 10.194L10.2746 9.15059C10.3438 9.10444 10.4235 9.07629 10.5063 9.06868C10.5891 9.06107 10.6725 9.07425 10.749 9.10701L13.6763 10.3616C13.7757 10.4038 13.8588 10.4772 13.9128 10.5708C13.9669 10.6643 13.9892 10.7729 13.9762 10.8801C13.8837 11.6041 13.5304 12.2696 12.9826 12.7519C12.4347 13.2342 11.7299 13.5003 11 13.5003C8.74566 13.5003 6.58365 12.6048 4.98959 11.0107C3.39553 9.41665 2.5 7.25465 2.5 5.00031C2.50004 4.27041 2.76612 3.56556 3.24843 3.01773C3.73073 2.46989 4.39618 2.11664 5.12019 2.02412C5.22745 2.01114 5.33602 2.03337 5.42955 2.08746C5.52307 2.14155 5.59649 2.22457 5.63873 2.32401L6.89439 5.25387C6.92687 5.32966 6.9401 5.4123 6.93291 5.49443C6.92572 5.57657 6.89833 5.65565 6.85318 5.72464L5.81341 7.31337C5.76608 7.38484 5.7381 7.46736 5.73221 7.55288C5.72631 7.63839 5.7427 7.72397 5.77977 7.80126V7.80126Z",
    stroke: "#545B5B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b581d3d7962c8fbe4f36ea9280986300.svg";
export { ForwardRef as ReactComponent };